// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  playerId: __t.string().name("player_id"),
  ruleset: __t.string(),
  territoryId: __t.string().name("territory_id"),
  name: __t.string(),
  status: __t.string(),
  controlled: __t.bool(),
  isStarter: __t.bool().name("is_starter"),
  tier: __t.u32(),
  x: __t.f64(),
  y: __t.f64(),
  battleMapsJson: __t.string().name("battle_maps_json"),
  unlockUnitsJson: __t.string().name("unlock_units_json"),
  unlockTechJson: __t.string().name("unlock_tech_json"),
  updatedAt: __t.timestamp().name("updated_at"),
});
